<div class="profile-toolbar-container">
  <button
    id="profile-toolbar-button"
    mat-icon-button
    [matMenuTriggerFor]="isUnEnabledForCurrentApp() && isMobile ? null : userMenu"
    [attr.aria-label]="'User profile'"
    (click)="openUserProfile()"
    (menuOpened)="closeSidenav()"
    class="profile-toolbar-button"
    [class.btn-hover]="!isDDorCollections()"
    #userProfileTrigger="matMenuTrigger"
    >
    <span id="profile-toolbar-name" class="user-name-toolbar  hide-on-mobile" >
      {{ patronToolbarName }}
    </span>
    @if(isUnEnabledForCurrentApp()) {
      <fa-icon class="profile-icon-new" [icon]="['fal', 'circle-user']" title="User Profile"></fa-icon>
      <fa-icon class="profile-icon-new-hover" [icon]="['fas', 'circle-user']" title="User Profile"></fa-icon>
    } @else {
      <mat-icon class="profile-icon" [svgIcon]="icons.USER_PROFILE" title="User Profile" ></mat-icon>
    }
  </button>
</div>

<mat-menu class="fss-user-profile-menu" #userMenu="matMenu">
  <ng-template #userProfile>
    <div
      class="user-profile"
      [class.un]="isUnEnabledForCurrentApp()"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      (keydown.tab)="$event.stopPropagation()"
      (keydown.shift.tab)="$event.stopPropagation()"
      >
      @if (isUnEnabledForCurrentApp()) {
        <div class="menu-section-header">
          <span class="section-header-name">Profile</span>
        </div>
      }

      <!-- Profile header -->
      <div class="profile-header" (click)="$event.stopPropagation()">
        @if(isThemeChangerEnabled() || isMessageSenderEnabled() || isSecretsEnabled()) {
          <mat-menu class="action-menu" #secretsMenu="matMenu" xPosition="before" [hasBackdrop]="false">
            <div cdkTrapFocus cdkTrapFocusAutoCapture="true" (keydown.tab)="$event.stopPropagation()" (keydown.shift.tab)="$event.stopPropagation()">
              @if (isThemeChangerEnabled()) {
                <fss-portal-theme-picker></fss-portal-theme-picker>
              }

              @if (isMessageSenderEnabled()) {
                <fss-portal-message-sender></fss-portal-message-sender>
              }

              @if (isSecretsEnabled()) {
                <fss-portal-secret></fss-portal-secret>
              }
            </div>
          </mat-menu>

          @if(isUnEnabledForCurrentApp()) {
            <fa-icon class="profile-icon-new" [icon]="['fal', 'circle-user']" title="User Profile" [matMenuTriggerFor]="secretsMenu" #secretsMenuTrigger="matMenuTrigger"></fa-icon>
          } @else {
            <mat-icon class="profile-icon" [svgIcon]="icons.USER_PROFILE" title="User Profile"  [matMenuTriggerFor]="secretsMenu" #secretsMenuTrigger="matMenuTrigger"></mat-icon>
          }
        } @else {
          @if(isUnEnabledForCurrentApp()) {
            <fa-icon class="profile-icon-new" [icon]="['fal', 'circle-user']" title="User Profile"></fa-icon>
          } @else {
            <mat-icon class="profile-icon" [svgIcon]="icons.USER_PROFILE" title="User Profile" ></mat-icon>
          }
        }

        <div class="profile-info">
          <p id="user-profile-patron-name" class="user-name">
            {{ patronName }}
          </p>
          @if (patronLocation) {
            <p id="user-profile-current-school" class="school-name">
              {{ patronLocation }}
            </p>
          }
          @if (!isUnEnabledForCurrentApp() || !patronLocation) {
            <p id="user-profile-district" class="district-name">
              {{ patronDistrict }}
            </p>
          }
        </div>
      </div>

      <!-- Profile items -->
      <div class="profile-items">
        @if (isUnEnabledForCurrentApp() && (canSeeInterestSurveyOption() || canSeeProfileOption())) {
          <mat-divider></mat-divider>
        }
        @if (canSeeProfileOption()) {
          <button
            mat-menu-item
            type="button"
            id="profile-profile"
            [ngClass]="{'item-highlight': highlightProfile}"
            (click)="gotoProfile()"
            class="profile-item"
            >
            Profile
          </button>
        }

        @if (canSeeInterestSurveyOption() && !isUnEnabledForCurrentApp()) {
          <button
            mat-menu-item
            type="button"
            id="profile-survey"
            [ngClass]="{'item-highlight': highlightInterestSurvey}"
            (click)="gotoInterestSurvey()"
            class="profile-item"
            >
            Interest Survey
          </button>
        }
        @if (accessToSettings) {
          <button
            mat-menu-item
            type="button"
            id="profile-preferences"
            (click)="gotoSettingApp('Preferences')"
            class="profile-item"
            >
            Preferences
          </button>
        }
        @if (accessToSettings && ( isDestinyAdmin || isSiteAdmin)) {
          <button
            mat-menu-item
            type="button"
            id="profile-settings"
            (click)="gotoSettingApp('Settings')"
            class="profile-item"
            >
            {{getSettingsMenuOption()}}
          </button>
        }

      </div>

      @if(showKioskSetting) {
        <div class="device-settings" [ngClass]="{'un-disabled': !isUnEnabledForCurrentApp()}"  (click)="$event.stopPropagation()">
          <div class="menu-section-header">
            <span class="section-header-name">Device settings</span>
          </div>
          <div class="kiosk-setting">
            Kiosk mode
            <mat-slide-toggle class="kiosk-slider"
              (change)="toggleKioskMode()"
              [checked]="isKioskEnabled"
              [attr.aria-label]="'Toggle kiosk mode, currently ' + (isKioskEnabled ? 'on' : 'off')"
              disableRipple
              hideIcon
              >
              <span class="kiosk-slider-text">{{isKioskEnabled ? 'On' : 'Off'}}</span>
            </mat-slide-toggle>
          </div>
        </div>
      }

      <div class="profile-items">
        @if (!isGuest) {
          <mat-divider></mat-divider>
          <button
            mat-menu-item
            type="button"
            id="profile-logout"
            (click)="logout()"
            class="profile-item"
            >
            Logout
          </button>
        }
      </div>

    </div>
  </ng-template>
  <ng-container [ngTemplateOutlet]="userProfile"></ng-container>
</mat-menu>
